import { SelectSuggestTypes, Text } from 'platform-components';
import { TEXT_MARKUP_TYPE } from 'platform-components/constants';
import { SUBJECTS_SLUGS_TYPE } from 'platform-components/src/typings';
import * as React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators, compose, Dispatch } from 'redux';

// @ts-ignore
import FormView from 'common.components/form-view/form-view';

import SuggestOption from '../__suggest-option/umk-modal__suggest-option';
import { RootAction, ReduxTeacherStore } from '../../../typings';
import * as actions from '../actions';
import { getFilteredSchoolbooksBySubject, getSelectedSchoolbookId } from '../selectors';
import { iSchoolbook } from '../typings';

interface OwnProps {
    subject: SUBJECTS_SLUGS_TYPE;
}

interface StoreProps {
    schoolbooks: Array<iSchoolbook>;
    selectedSchoolbookId: string | null;
}

interface DispatchProps {
    filterSchoolbooks: (subject: SUBJECTS_SLUGS_TYPE, input: string) => void;
    selectSchoolbook: (subject: SUBJECTS_SLUGS_TYPE, schoolbook: string | null) => void;
}

interface SchoolbookSuggestProps extends OwnProps, StoreProps, DispatchProps {
    intl: IntlShape;
}

export class SchoolbookSuggest extends React.Component<SchoolbookSuggestProps> {
    componentWillUnmount(): void {
        const { subject, selectSchoolbook } = this.props;

        selectSchoolbook(subject, null);
    }

    handleUMKChange = (schoolbook: iSchoolbook) => {
        const { subject, selectSchoolbook } = this.props;

        selectSchoolbook(subject, schoolbook.id);
    };

    handleInputChange = (value: string) => {
        const { subject, filterSchoolbooks } = this.props;
        const trimmed = value.trim();

        filterSchoolbooks(subject, trimmed);
    };

    render() {
        const { intl, schoolbooks, selectedSchoolbookId, subject } = this.props;

        return (
            <React.Fragment>
                <div className="umk-modal__select-label">
                    <Text id={`UMKModal.header.${subject}`} type={TEXT_MARKUP_TYPE.MARKDOWN} />
                </div>
                {schoolbooks && (
                    <FormView.Suggest
                        labelKey="author"
                        mix="umk-modal__form-select"
                        onChange={this.handleUMKChange}
                        onInputChange={this.handleInputChange}
                        optionRenderer={SuggestOption}
                        options={schoolbooks}
                        placeholder={intl.formatMessage({ id: 'UMKModal.form.chooseSchoolbook' })}
                        type={SelectSuggestTypes.SELECT}
                        value={selectedSchoolbookId}
                        valueKey="id"
                    />
                )}
            </React.Fragment>
        );
    }
}

const mapStateToProps = (storeState: ReduxTeacherStore, ownProps: OwnProps): StoreProps => {
    const { subject } = ownProps;

    return {
        schoolbooks: getFilteredSchoolbooksBySubject(storeState, { subject }),
        selectedSchoolbookId: getSelectedSchoolbookId(storeState, { subject }),
    };
};

const mapDispatchToProps = (dispatch: Dispatch<RootAction>): DispatchProps => {
    const { filterSchoolbooks, selectSchoolbook } = actions;

    return bindActionCreators(
        {
            filterSchoolbooks,
            selectSchoolbook,
        },
        dispatch
    );
};

export default compose<any>(connect(mapStateToProps, mapDispatchToProps), injectIntl)(SchoolbookSuggest);
